import React, {useState} from 'react';
import {ActionIcon, Center, Group, Tooltip} from '@mantine/core';
import classes from './Header.module.css';
import {
  IconChartBar,
  IconEdit,
  IconGauge,
  IconLayoutGrid,
  IconShield,
  IconShieldOff,
  IconUsersGroup,
} from '@tabler/icons-react';
import {Link, useLocation} from 'react-router-dom';
import {RouteUtils} from '@bobex/react-core/routes/RouteUtils';
import {authorityGuardDevStore} from '@bobex/react-core/routes/authorityGuardDevStore';

const links = [
  {
    link: '/dashboard',
    label: 'Dashboard',
    icon: IconGauge,
    color: 'green',
  },
  { link: '/sitemap', label: 'Sitemap', icon: IconLayoutGrid, color: 'indigo' },
  {
    link: '/charts-home',
    label: 'Charts',
    icon: IconChartBar,
    color: 'blue',
  },
  {
    link: RouteUtils.getBackofficeServletBasename() + '/bo_partner_rfp_searchform',
    label: 'Search lead',
    icon: IconEdit,
    color: 'yellow',
  },
  {
    link: '/search-user',
    label: 'Search user',
    icon: IconUsersGroup,
    color: 'red',
  },
];

export default function Header() {
  const { pathname } = useLocation();
  const [devEnabled, setDevEnabled] = useState(() =>
    import.meta.env.DEV ? authorityGuardDevStore.isEnabled() : false
  );

  const items = links.map((link, index) => {
    const isActive = pathname === link.link || pathname.startsWith(`${link.link}/`);

    return (
    <React.Fragment key={index}>
      <ActionIcon
        color={link.color}
        size="lg"
        key={link.label}
        component={Link}
        to={link.link}
        className={classes.link}
        data-active={isActive || undefined}
        variant={isActive ? 'outline' : 'filled'}
        aria-current={isActive ? 'page' : undefined}
      >
        <Center>
          {link.icon && <link.icon size={20} />}
          {/*{link.label}*/}
        </Center>
      </ActionIcon>
    </React.Fragment>
    );
  });

  return (
    <Group justify="space-between" wrap={'nowrap'}>
      {items}
      {import.meta.env.DEV && (
        <Tooltip label={devEnabled ? 'Disable AuthorityGuard overlay' : 'Enable AuthorityGuard overlay'}
                 withArrow>
          <ActionIcon
            color={devEnabled ? 'violet' : 'gray'}
            size="lg"
            variant={devEnabled ? 'filled' : 'outline'}
            onClick={() => setDevEnabled(authorityGuardDevStore.toggle())}
            aria-label="Dev mode"
          >
            <Center>{devEnabled ? <IconShield size={20}/> : <IconShieldOff size={20}/>}</Center>
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  );
}
